import Utils from '../Utils'

const Periscope = {
    init() {
        if (this.cacheDom()) {
            this.bindEvents()
        }
    },

    cacheDom() {
        // Establish all dom elements we need to reference
        // and then return a boolean so we know we have elements to handle
        this.header = document.querySelector('[data-periscope]')
        return this.header
    },

    /**
     * Sets up initial state and mutable tracking values.
     * @returns {void}
     */
    setState() {
        this.lastScrollY = window.scrollY
        this.ticking = false
        this.hiddenClass = 'is-hidden'
        this.syncHeaderHeight()
    },

    /**
     * Compares current scroll position against the last known position
     * to determine direction, then toggles visibility accordingly.
     * @returns {void}
     */
    scroll() {
        const currentScrollY = window.scrollY
        const scrollingDown = currentScrollY > this.lastScrollY
        const pastHeaderHeight = currentScrollY > (this.headerHeight / 2)

        if (scrollingDown && pastHeaderHeight) {
            this.hide()
        } else {
            this.show()
        }

        this.lastScrollY = currentScrollY
        this.ticking = false
    },

    /**
     * Translates the header out of view above the viewport.
     * @returns {void}
     */
    hide() {
        this.header.classList.add(this.hiddenClass)
    },

    /**
     * Slides the header back into view.
     * @returns {void}
     */
    show() {
        this.header.classList.remove(this.hiddenClass)
    },

    /**
     * Recalculates cached measurements after resize/orientation change,
     * since header height can change with responsive breakpoints.
     * @returns {void}
     */
    handleResize() {
        this.syncHeaderHeight()
    },

    /**
     * Reads the CSS-defined --header-height (including breakpoint values)
     * by clearing any inline override, then caches the measured height
     * and writes it back for layout that depends on the computed pixel value.
     * @returns {void}
     */
    syncHeaderHeight() {
        const root = document.documentElement
        root.style.removeProperty('--header-height')
        this.headerHeight = this.header.offsetHeight
        root.style.setProperty('--header-height', `${this.headerHeight}px`)
    },

    /**
     * Batches scroll handling to the next animation frame so we're not
     * running comparison logic on every single scroll event firing.
     * @param {Event} e - The event object
     * @returns {void}
     */
    onScroll(e) {
        if (!this.ticking) {
            window.requestAnimationFrame(() => this.scroll())
            this.ticking = true
        }
    },

    /**
     * Handles binding
     * @returns {void}
     */
    bindEvents() {
        this.setState()

        window.addEventListener('scroll', (e) => this.onScroll(e), { passive: true })

        // Resize doesn't need frame-by-frame precision like scroll does,
        // so debounce it instead of throttling with rAF.
        // window.addEventListener('resize', Utils.debounce((e) => this.handleResize(e), 150))
        window.addEventListener('resize', (e) => this.handleResize(e))
    }
}

export default Periscope